import React from 'react';
import PropTypes from 'prop-types';
import '../cartaGeneral.css';
import '../cartaResto.css';
import ImageContainer from '../ImagesContainer';
import getClassName from '../getClassName';

const SingleSectionTable = ({ section, isResto }) => {
  return (
    <div
      className={getClassName('containerClass', isResto)}
      key={section.title}
    >
      <h1 className={getClassName('sectionTitle', isResto)}>
        {`${section.title}${section.engTitle ? ` (${section.engTitle})` : ''}`}
      </h1>
      <hr className={getClassName('separatorClass', isResto)} />
      <div className={getClassName('tableContainer', isResto)}>
        <table className={getClassName('tableClass', isResto)}>
          <tbody>
            {section.items.map((item) => {
              return (
                <tr
                  className={getClassName('trElement', isResto)}
                  key={item.text}
                >
                  <td
                    className={getClassName('tdElement', isResto)}
                    style={{ width: '90%' }}
                  >
                    <h5 className={getClassName('h5Element', isResto)}>
                      {item.text}
                    </h5>
                    {item.engText && (
                      <h5 className={getClassName('h5Element', isResto)}>
                        {`(${item.engText})`}
                      </h5>
                    )}
                  </td>
                  <td
                    className={getClassName('tdElement', isResto)}
                    style={{ width: '10%' }}
                  >
                    <h5 className={getClassName('h5Element', isResto)}>
                      {item.price ? `$${item.price}` : '-'}
                    </h5>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ImageContainer
        imgLg={section.imgLg}
        imgSm={section.imgSm}
        img={section.img}
        title={section.title}
        isResto={isResto}
      />
    </div>
  );
};

SingleSectionTable.propTypes = {
  section: PropTypes.shape({
    imgLg: PropTypes.any,
    imgSm: PropTypes.any,
    img: PropTypes.any,
    title: PropTypes.string,
    engTitle: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({ text: PropTypes.string, price: PropTypes.any })
    ),
  }),
  isResto: PropTypes.bool,
};

SingleSectionTable.defaultProps = {
  isResto: false,
};

export default SingleSectionTable;
